// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"43":"a2402db5","206":"d43c7976","886":"b905db92","927":"5108f0c2"}[chunkId] + ".chunk.css";
};